<template>

  <div class="padded">
    <h2><i class="fa fa-tools">&nbsp;</i><org-badge /> Dashboard<small v-if="!isTowerCo() && org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small></h2>
    <br />
    <br />

    <div v-if="org() && org().id">

      <el-tabs tab-position="top">

        <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-wrench"></i> Tickets</span>
               <tickets-table :assign-id="org().id" />
        </el-tab-pane>

        <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-tasks"></i> Work List</span>
              <site-workflow :org-id="org().id" />
        </el-tab-pane>

        <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-calendar"></i> Summary</span>
            <ticket-summary />
        </el-tab-pane>

        <el-tab-pane lazy>
            <span slot="label"><i class="fa fa-calendar"></i> Calendar</span>
            <events-calendar category="tickets" />
        </el-tab-pane>

      </el-tabs>

    </div>
    <div v-else>
        <center><i class="fa fa-spinner fa-2x fa-spin text-primary"></i></center>
    </div>

  </div>

</template>

<script>

import EventsCalendar from '@/components/atoms/EventsCalendar'
import SiteWorkflow from '@/components/workflow/site/SiteWorkflow'

import TicketsTable from '@/components/tables/TicketsTable'
import TicketSummary from '@/components/dashboard/maintenance/TicketSummary'

export default {

  components: {
    EventsCalendar,
    SiteWorkflow,
    TicketSummary,
    TicketsTable
  }

}

</script>
